import { render } from "./CreateReview.vue?vue&type=template&id=a2ec75fe&scoped=true"
import script from "./CreateReview.vue?vue&type=script&lang=js"
export * from "./CreateReview.vue?vue&type=script&lang=js"

import "./CreateReview.vue?vue&type=style&index=0&id=a2ec75fe&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ec75fe"]])

export default __exports__